import React from 'react';
import { Image, DEFAULT_FALLBACKS } from 'components/Image';
import { ENV_CONFIG } from 'config/environment';
import { useAppSelector } from 'helpers/hooks';
import { getRecipientsData } from 'selectors/recipients';

interface RecipientProps {
  selectedRecipient: { value: string; label: string };
}

export const RecipientHeaderInfo = React.memo(({ selectedRecipient }: RecipientProps) => {
  const recipients = useAppSelector(getRecipientsData);
  const recData = recipients.find(rec => rec.recipient_id === selectedRecipient.value);

  return (
    <div className="flex-wrap-nowrap">
      <Image
        src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${recData?.misc_ids?.photo_id}.jpg`}
        alt={recData?.recipient_name || ''}
        className="search-image"
        fallbackImgType="candidate_square"
      />
      <div className="grid content-center">
        <span className="oath-bodysmall">{recData?.recipient_name}</span>
        <span className="oath-bodysmall">{recData?.race?.election.display_info}</span>
      </div>
    </div>
  );
});
RecipientHeaderInfo.displayName = 'RecipientHeaderInfo';

export const PaymentOptionHeaderInfo = React.memo(
  ({ label, imageUrl }: { label: string; imageUrl?: string }) => {
    const src = imageUrl?.trim() ? imageUrl : DEFAULT_FALLBACKS.gradient_square;

    return (
      <div className="flex-wrap-nowrap">
        <Image src={src} alt={label} className="search-image" fallbackImgType="candidate_square" />
        <div className="grid content-center">
          <span className="oath-bodysmall">{label}</span>
        </div>
      </div>
    );
  }
);
PaymentOptionHeaderInfo.displayName = 'PaymentOptionHeaderInfo';

export const FilterHeaderInfo = React.memo(
  ({ position, label, description }: { position: number; label: string; description: string }) => (
    <div className="flex-wrap-nowrap align-center">
      <span className="oath-bodysmall gray drag-row-position">{position}</span>
      <div className="grid content-center">
        <span className="oath-bodysmall filter-row__name">{label}</span>
        <span className="oath-bodysmall gray">{description}</span>
      </div>
    </div>
  )
);
FilterHeaderInfo.displayName = 'FilterHeaderInfo';
